"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.init = void 0;
var ts_exhaustive_check_1 = require("ts-exhaustive-check");
var CalendarState = __importStar(require("../calendar/calendar-state"));
var date_utils_1 = require("../date-utils");
function init() {
    return {
        selectedYear: (0, date_utils_1.getCurrentYear)(),
        selectedMonth: (0, date_utils_1.getCurrentMonth)() + 1,
        selectedCalendar: "divid",
        calendarState: CalendarState.init(),
    };
}
exports.init = init;
function reducer(state, action) {
    switch (action.type) {
        case "SetSelectedCalendar": {
            return __assign(__assign({}, state), { selectedCalendar: action.payload, calendarState: CalendarState.init() });
        }
        case "SetMonth": {
            return __assign(__assign({}, state), { selectedYear: action.payload.year, selectedMonth: action.payload.month });
        }
        case "DispatchCalendar": {
            return __assign(__assign({}, state), { calendarState: CalendarState.reducer(state.calendarState, action.action) });
        }
        default: {
            return (0, ts_exhaustive_check_1.exhaustiveCheck)(action, true);
        }
    }
}
exports.reducer = reducer;
//# sourceMappingURL=main-state.js.map